import http from '@/core/http'
// eslint-disable-next-line
import { map } from 'lodash'
// eslint-disable-next-line
// import moment from 'moment'


const state = {
  itens: [],
  configGecom: {},
  totais: {}
}

const actions = {
  getItens: async ({ commit }, payload) => {
    const result = await http.get('gecom-home/gefin-mobile', { headers: { moduloname: 'relatorios' }, params: payload })
    if (result.data.data.status === -1) throw new Error(result.data.data.message)
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },

  clearItens () {}
}

const mutations = {
  'LISTA_ITENS' (state, payload) {
    state.itens = payload.data.data
    state.configGecom = payload.paramsConfig
    state.totais = payload.totais
  }
}

const getters = {
  listaItens: state => state.itens,
  configGecom: state => state.configGecom,
  totais: state => state.totais,
}

export default { namespaced: true, state, actions, mutations, getters }